import { useQuery } from "@tanstack/react-query";
import { Undo2Icon } from "lucide-react";

import { Button } from "~/components/ui/button";

import { formatRelativeTime } from "../event-queue/eventQueueFormat";
import { useArtifactRestore } from "./artifacts/ArtifactActions";
import { dashboardArtifactsTrashQueryOptions } from "./artifacts/artifactsReactQuery";
import type { DashboardArtifactSummary } from "./artifacts/artifactTypes";

function DeletedRow(props: { artifact: DashboardArtifactSummary }) {
  const { artifact } = props;
  const restore = useArtifactRestore(artifact);
  return (
    <li className="flex items-center justify-between gap-3 py-2">
      <div className="min-w-0">
        <p className="truncate text-sm font-medium text-foreground">{artifact.title}</p>
        <p className="text-xs text-muted-foreground">
          Deleted {formatRelativeTime(artifact.updatedAt)}
        </p>
      </div>
      <Button
        disabled={restore.isPending}
        onClick={() => restore.mutate()}
        size="sm"
        variant="outline"
      >
        <Undo2Icon aria-hidden />
        Restore
      </Button>
    </li>
  );
}

/** What this person deleted and may still restore. Shows nothing when there is nothing. */
export function RecentlyDeletedSection() {
  const query = useQuery(dashboardArtifactsTrashQueryOptions());
  if (!query.data || query.data.length === 0) return null;
  return (
    <details className="rounded-xl border border-border/70 px-4 py-2">
      <summary className="cursor-pointer text-sm font-medium text-muted-foreground">
        Recently deleted ({query.data.length})
      </summary>
      <ul aria-label="Recently deleted dashboards" className="divide-y divide-border/60">
        {query.data.map((artifact) => (
          <DeletedRow key={artifact.id} artifact={artifact} />
        ))}
      </ul>
    </details>
  );
}
